import { motion, useIsPresent } from 'framer-motion'
import { CSSProperties, FC } from 'react'

import CircleCheckIcon from '@/assets/icons/circle-check-filled.svg?react'
import CircleXIcon from '@/assets/icons/circle-x-filled.svg?react'
import CircleInfoIcon from '@/assets/icons/info-circle-filled.svg?react'
import { cn } from '@/utils/style'

import { MessageType } from './type'

interface MessageProps {
  message: MessageType
  className?: string
}

export function Message({ message, className }: MessageProps) {
  const icons: Record<MessageType['type'], FC<any>> = {
    default: CircleInfoIcon,
    error: CircleXIcon,
    success: CircleCheckIcon,
  }

  const IconComp = icons[message.type]

  const isPresent = useIsPresent()

  const animations = {
    style: {
      position: (isPresent ? 'static' : 'absolute') as CSSProperties['position'],
    },
    initial: { scale: 0.5, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.5, opacity: 0 },
    transition: { type: 'spring', stiffness: 600, damping: 50 },
  }

  return (
    <motion.div {...animations} layout>
      <div
        className={cn(
          'flex bg-white rounded-lg border-gray-200 border px-4 py-3 items-center shadow-lg gap-2 t-sm',
          className,
        )}
      >
        <div
          className={cn('flex items-center justify-center text-btn-secondary', {
            'text-red-600': message.type === 'error',
            'text-green-600': message.type === 'success',
          })}
        >
          <IconComp className="w-5 h-5" />
        </div>
        {message.content}
        {message.action}
      </div>
    </motion.div>
  )
}
